import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"

import CountTo from 'vue-count-to'
Vue.component('count-to', CountTo)

Vue.config.productionTip = false

// 引入$cookie
import VueCookie from "vue-cookie"
Vue.use(VueCookie)

// 引入md5
import md5 from "js-md5"
Vue.prototype.$md5 = md5

// 引入E-chart
const echarts = require("echarts")
Vue.prototype.$echarts = echarts

// 引入jQuery
import $ from "jquery"
Vue.prototype.$ = $

//引入element
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
Vue.use(ElementUI)

// 引入全局混入
import MinXin from "../src/config/miXins.js"
Vue.mixin(MinXin)

// 不传参url
import ajax_url from "../src/config/ajax_url.js"
Vue.prototype.ajax_url = ajax_url
// 刘新增url
import ajax_url1 from "../src/config/ajax_url1.js"
Vue.prototype.ajax_url1 = ajax_url1

// 传id
import ajax_id from "../src/config/ajax_id.js"
Vue.prototype.ajax_id = ajax_id
// 传id
import ajax_id1 from "../src/config/ajax_id1.js"
Vue.prototype.ajax_id1 = ajax_id1

// 传number获取新闻
import ajax_number from "../src/config/ajax_number.js"
Vue.prototype.ajax_number = ajax_number

// 传对象
import ajax_data from "../src/config/ajax_data.js"
Vue.prototype.ajax_data = ajax_data
// 传对象
import ajax_data1 from "../src/config/ajax_data1.js"
Vue.prototype.ajax_data1 = ajax_data1

// 图片上传组件
import ImageUpload from "../src/components/ImageUpload"

Vue.component("ImageUpload", ImageUpload)

import modal from "./util/modal"
// 模态框对象
Vue.prototype.$modal = modal

// 引入axios
import axios from "axios"
Vue.prototype.$axios = axios
axios.create({ withCredentials: true })

import { resetForm } from "../src/util/ruoyi"
import Home from "./views/Home.vue"

Vue.prototype.resetForm = resetForm


//请求封装
Vue.prototype.request = function (url, method, data1, success, header) {
  let data = data1
  this.$axios({
    url: url,
    method: "POST",
    headers:
      header ||
      {

      },
    data: method == "POST" ? data : {},
    params: method == "GET" ? data : {}
    // params: method == 'GET' ? JSON.stringify(data) : {},
  })
    .then(res => {
      if (success) {
        success(res.data)
      }
    })
    .catch(res => {
      console.log(res)
    })
}

// 展示文字方法封装
Vue.prototype.setPorjectShowStatus = (status = "", isApply = 0) => {
  if (status == "") {
    return "未传参(status)"
  }
  status = Number(status)
  let defaultStatusList = [
    "",
    "",
    "公示中",
    "公示结束",
    "报名中",
    "报名结束",
    "竞价中",
    "已成交",
    "已成交",
    "已成交",
    "已结束",
    "已结束",
  ]
  if (status == "4" && isApply == "0") {
    return "我要报名"
  } else if (status == "4" && isApply == "1") {
    return "报名成功"
  } else if (status == "4" && isApply == "2") {
    return "已报名待审核"
  } else if (status == "6" && isApply == "1") {
    return "我要出价"
  } else if (status == "6" && isApply != "1") {
    return "未报名"
  } else {
    return (cityDetail.projectCardShowStatusList ? cityDetail.projectCardShowStatusList[status] : defaultStatusList[status])
  }
}

function getParams () {
  if (window.location.hash.indexOf("?") < 0) {
    return false
  }
  let hashStr = window.location.hash.split("?")[1]
  let hashStrList = hashStr.split("&")
  let params = {}
  hashStrList.forEach(item => {
    params[item.split("=")[0]] = item.split("=")[1]
  })
  if (params.type && params.type == 3) {
    return true
  } else {
    return false
  }
}
Vue.prototype.typeList = cityDetail.projectTypeList || [
  {
    label: getParams() ? '我要买' : '供应项目',
    type: 2,
    li_bg: [],
  },
  {
    label: getParams() ? '我要卖' : '需求项目',
    type: 3,
    li_bg: [],
  },
  {
    label: cityDetail.customZTBName ? cityDetail.customZTBName : '招投标项目',
    type: 1,
    li_bg: [],
  },
]

// 分类全部对象
Vue.prototype.mainType = {
  activeImg: require('@/assets/img/全部x1.png'),
  lazyImg: require('@/assets/img/全部x01.png'),
  mainImg: require('@/assets/img/全部.png'),
  code: "",
  name: '全部'
}

import { cityDetail } from "./util/mainOption.js"
Vue.prototype.cityDetail = cityDetail

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")
